import React from 'react';
import Checkbox from 'apollo-react/components/Checkbox';
import Typography from '../StyledTypography';
import './common.css';

const CheckboxInput = ({
  field = {},
  meta = {},
  label,
  onChange,
  value,
  required,
  checked,
  style,
  disabled,
}) => {
  checked = checked !== undefined ? checked : (field.value ?? false);
  const handleChange = (event) => {
    if (typeof onChange === 'function') {
      onChange(event.target.checked);
    }
  };

  const errorMessage = meta.touched && meta.error ? meta.error : '';

  return (
    <div className="checkbox-input-wrapper">
      <Checkbox
        {...field}
        label={label}
        checked={checked}
        onChange={handleChange}
        error={!!errorMessage}
        required={required}
        value={value}
        style={style}
        disabled={disabled}
      />
      {errorMessage ? (
        <Typography variant="caption" className="checkbox-input-error">
          {errorMessage}
        </Typography>
      ) : null}
    </div>
  );
};

export default CheckboxInput;
